import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { JURISDICTION_ACTION_TYPE } from "@obg/ngx.core";
import { asyncScheduler } from "rxjs";
import { distinctUntilChanged, map, mergeMap, observeOn } from "rxjs/operators";

import { APP_LIFE_CYCLE_ACTION_TYPE } from "../app-lifecycle/app-lifecycle.action";
import { DataProtectionSelector } from "../data-protection/data-protection.selector";
import { CommonState } from "../state";

import { CookieNoticeAction } from "./cookie-notice.action";
import { CookieNoticeConfigService } from "./cookie-notice.config";

@Injectable()
export class CookieNoticeEffect {
	setEnabled$ = createEffect(() =>
		this.actions$.pipe(
			ofType(APP_LIFE_CYCLE_ACTION_TYPE.initSuccess, JURISDICTION_ACTION_TYPE.set),
			observeOn(asyncScheduler),
			map(() => this.config.getEnable()),
			distinctUntilChanged(),
			mergeMap((isCookieNoticeEnabled) =>
				this.store
					.pipe(this.dataProtectionSelector.isGdprEnabledForCurrentCountry$())
					.pipe(
						map((isGdprEnabledCountry) =>
							this.action.setEnabled(isCookieNoticeEnabled && !isGdprEnabledCountry)
						)
					)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: CookieNoticeAction,
		private dataProtectionSelector: DataProtectionSelector,
		private config: CookieNoticeConfigService,
		private store: Store<CommonState>
	) {}
}
